import React from "react";
import { FiChevronRight } from "react-icons/fi";
import CircleIcon from "./CircleIcon";

const ChevronRightIcon = FiChevronRight;

const PersonRow = ({ icon, title, subtitle, onClick, tone = "green", badge }) => {
  const Component = typeof onClick === "function" ? "button" : "div";

  return (
    <Component
      type={typeof onClick === "function" ? "button" : undefined}
      onClick={onClick}
      className="grid w-full grid-cols-[3.25rem_minmax(0,1fr)_auto] items-center gap-3 rounded-2xl bg-transparent py-2 text-left"
    >
      <CircleIcon tone={tone}>{icon}</CircleIcon>
      <span className="min-w-0">
        <span className="block truncate text-[1rem] font-black leading-tight text-slate-950 dark:text-slate-50">
          {title}
        </span>
        {subtitle && (
          <span className="mt-1 block truncate text-[0.86rem] font-semibold leading-tight text-slate-500 dark:text-slate-400">
            {subtitle}
          </span>
        )}
        {badge}
      </span>
      {typeof onClick === "function" && (
        <ChevronRightIcon className="h-6 w-6 text-emerald-600" aria-hidden="true" />
      )}
    </Component>
  );
};

export default PersonRow;
